import React, { FC, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import MwdDialog from '@/components/UI/Dialog/Dialog';
import FieldGroup from '@/components/UI/Fields/FieldGroup';
import Input from '@/components/UI/Fields/Input';
import { Label } from '@/components/UI/Label/Label';

import useInregelenDialog from './useInregelenDialog';

import styles from '@/components/UI/Dialog/Dialog.module.css';

type ToevoegenInregelenDialogProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
  details: WerklijnContextMenuDetails;
  isUpdate?: boolean;
};

const ToevoegenInregelenDialog: FC<ToevoegenInregelenDialogProps> = ({
  showDialog,
  handleOpenChange,
  details,
  isUpdate = false,
}) => {
  const { handleSubmit, resetDialog, onSubmit, setValue } = useInregelenDialog(details, handleOpenChange, isUpdate);
  const [selectedDate, setSelectedDate] = useState('');

  useEffect(() => {
    if (showDialog) {
      const initieleDatum = details.inregelingDatum ? details.inregelingDatum : format(new Date(), 'yyyy-MM-dd');
      setValue('datum', initieleDatum);
      setSelectedDate(initieleDatum);
    }
  }, [showDialog]);

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setValue('datum', newDate);
    setSelectedDate(newDate);
  };

  return (
    <MwdDialog
      title='Inregelen'
      className={styles.inregelenDialogStyle}
      showDialog={showDialog}
      handleOpenChange={handleOpenChange}
      data-testid={`contextMenu-${details.eenheidnummer}`}
      hasCloseInHeader={true}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Label>Eenheid</Label>
          <div style={{ color: 'var(--tractie-color-content-default)' }}>
            {details.eenheidnummer} ({details.materieelSoort}-{details.materieelAanduiding})
          </div>
          <div
            style={{
              height: '2px',
              marginBottom: '8px',
              marginTop: '8px',
              width: '272px',
              background: 'var(--tractie-color-border-subtle)',
            }}
          />
        </div>
        <div style={{ marginBottom: '24px' }}>
          <FieldGroup.Col
            boxProps={{ width: '272px' }}
            required
            fieldId='inregelingDatum'
            FieldComponent={Input.Date}
            label='Datum'
            value={selectedDate}
            onChange={handleDateChange}
          />
        </div>
        <MwdDialog.Footer submitCaption='Inregelen' cancelCallback={() => resetDialog(true)} />
      </form>
    </MwdDialog>
  );
};
export default ToevoegenInregelenDialog;
